<template>
  <div id="documents">
    <div v-if="post.logo" class="logoEntreprise">
      <img :src="'/api/logoClient?v='+post.id" alt=""/>
    </div>
    <div>
      <el-tabs type="card" v-model="activeName">
        <el-tab-pane label="Devis" name="first"><devis/></el-tab-pane>
        <el-tab-pane label="Commandes" name="second"><commandes/></el-tab-pane>
        <el-tab-pane label="Factures" name="third"><factures/></el-tab-pane>
        <el-tab-pane label="Contrats" name="fourth"><contrats/></el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>

<style>
#documents{
  margin: auto;
  width: 99%;
  text-align: center;
}

#documents .el-tabs__nav.is-top{
  float: none;
}

#contrat > h3, #contrat .table thead th, #contrat .table td,#contrat .table th{
  border-color: #3C4694;
}

#devis > h3, #devis .table thead th, #devis .table td,#devis .table th{
  border-color: #6D3D94;
}

#commande > h3, #commande .table thead th, #commande .table td,#commande .table th{
  border-color: #ED2C74;
}

#facture > h3, #facture .table thead th, #facture .table td,#facture .table th{
  border-color: #00B7A7;
}

#documents .input-group{
  width: 60%;
}

#documents .input-group>.form-control{
  flex: 1 1 50%;
}

#visualDoc{
  width: 100%;
  height: 100%;
}

#modalVisual > .modal-dialog {
  max-width: 50%;
  height: 95%;
  margin-top: 1%;
}

#modalVisual > .modal-body {
  max-height: 90%;
  padding: 0;
  overflow: unset;
}

#modalVisual > .modal-dialog > div{
  height: 100%;
}

</style>

<script>
import script from '../../../script/script.js';
import devis from './DevisClient.vue'
import factures from './FacturesClient.vue'
import commandes from './CommandesClient.vue'
import contrats from './ContratsClient.vue'
export default {
  data() {
    return {
      post: {},
      activeName: 'first',
      modalVisual: { title: '', content: '' },
      visualSrc:''
    }
  },
  mounted:function(){
    this.$store.commit("resetDocuments")
    this.verifyRight();
    this.loadingInfo();
  },
  methods: {
    verifyRight: script.verifyRight,
    visualDoc: script.visualDoc,
    loadingInfo: script.loadingInfo
  },
  components: {
    devis,
    factures,
    commandes,
    contrats
  },
  computed: {
  
  }
}
</script>
